export default {
      id: "thermo-usage",
      viewBox: "0 0 305 108",
      url: __webpack_public_path__ + "sprite.svg#thermo-usage",
      toString: function () {
        return this.url;
      }
    }